// extracted by mini-css-extract-plugin
export default {"Invoices":"BillInvoices_Invoices__oB6w3","InvoicesList":"BillInvoices_InvoicesList__fj+nX","InvoicesHeader":"BillInvoices_InvoicesHeader__kGr-6"};